<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :isShowLaborPrice="isShowLaborPrice"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @checkboxChange="checkboxChange"
      @openEditPage="openEditPage"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openEditPage="openEditPage"
      >
        <template slot-scope="{ form }">
          <b-button
            v-if="allow('E')"
            size="sm"
            class="ml-2"
            variant="outline-success"
            @click="exportFile(form)"
          >
            {{ '导出' }}
            <i class="el-icon-download" />
          </b-button>

          <b-dropdown
            v-if="allow('I')"
            variant="outline-primary"
            size="sm"
            class="ml-2"
          >
            <template #button-content>
              <span @click.stop="importFile()">
                {{ $l('btn_import') || '导入' }}
              </span>
            </template>
            <b-dropdown-item @click.stop="chooseTemplateVisible = true">
              {{ $l('btn_download_template') || '下载模版' }}
            </b-dropdown-item>
          </b-dropdown>
          <el-badge
            v-if="allow('B')"
            :value="checkedRowCount"
            :hidden="!checkedRowCount"
            class="submit-button ml-2"
            :class="{ clearable: !!checkedRowCount }"
          >
            <b-button
              size="sm"
              variant="outline-danger"
              @click="batchSubmit"
              :disabled="!checkedRowCount"
            >
              {{ $l('btn_batch_submit') || '批量提报' }}
              <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
            </b-button>
          </el-badge>
        </template>
      </PageHeader>
      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>
    <EditForm
      v-if="openEditDialogOptions.editFormVisible"
      :visible.sync="openEditDialogOptions.editFormVisible"
      :disabled="openEditDialogOptions.disabled"
      :title="openEditDialogOptions.title"
      :pendingGoodsWorklogCode="openEditDialogOptions.pendingGoodsWorklogCode"
      :pendingGoodsCode="openEditDialogOptions.pendingGoodsCode"
      @reload="reload"
    ></EditForm>
    <ChooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{
        templateGroup: chooseTemplateOptions.templateGroup,
        custCode:
          isShowLaborPrice == 'Y'
            ? 'factory-lineReport-laborPrice'
            : 'factory-lineReport-not-laborPrice',
      }"
      :exportOptions="{
        params: { searchForm: chooseTemplateOptions.searchForm },
      }"
    />

    <ImportFile ref="importFile" @reload="reload" />

    <ChooseImportTemplate
      :visible.sync="chooseTemplateVisible"
      :templateQueryParams="{ templateGroup: 'factory-prodLineReport-import' }"
    />
  </div>
</template>
<script>
import { VXETable } from 'vxe-table'
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import EditForm from '../edit-form'
import ChooseTemplate from '@/views/factory/components/choose-template'
import ImportFile from '../import-file'
import ChooseImportTemplate from '@/views/factory/components/choose-import-template'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [BaseTable, EditLoading],
  components: {
    PageMain,
    PageHeader,
    EditForm,
    ChooseTemplate,
    ImportFile,
    ChooseImportTemplate,
  },
  data() {
    return {
      usePage: true,
      isShowLaborPrice: 'N',

      openEditDialogOptions: {
        editFormVisible: false,
        pendingGoodsWorklogCode: '',
      },
      chooseTemplateOptions: {
        visible: false,
        templateGroup: 'factory-prodLineReport',
        searchForm: {},
      },
      chooseTemplateVisible: false,
      checkedRows: [],
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
    checkedCodes() {
      return [
        ...new Set(
          this.checkedRows
            .map((item) => item.pendingGoodsWorklogCode)
            .filter(Boolean)
        ),
      ]
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .pendingGoodsWorkLogListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.isShowLaborPrice = res.body.isShowLaborPrice
          const param = res.body?.list
          const { pageSize, curPage, count, data } = param
          this.tableData = data || []
          this.page.pageTotal = count
          this.page.pageSize = pageSize
          this.page.curPage = curPage
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditPage({ pendingGoodsWorklogCode, pendingGoodsCode, menuType }) {
      const types = {
        add: '新增产线报工记录信息',
        edit: '编辑产线报工记录信息',
        detail: '产线报工记录详情',
      }

      this.openEditDialogOptions.editFormVisible = true
      this.openEditDialogOptions.disabled = menuType == 'detail'
      this.openEditDialogOptions.title = types[menuType]
      this.openEditDialogOptions.pendingGoodsWorklogCode = pendingGoodsWorklogCode
      this.openEditDialogOptions.pendingGoodsCode = pendingGoodsCode
    },
    exportFile(form) {
      this.chooseTemplateOptions.visible = true
      this.chooseTemplateOptions.searchForm = {
        ...form,
      }
    },
    async importFile() {
      const types = ['xlsx', 'XLSX']
      const { file } = await VXETable.readFile({ types }).catch(() => ({}))
      if (!file) return

      this.$refs.importFile.open({ file })
    },
    async checkboxChange(data) {
      this.checkedRows = data
    },
    clearCheckboxRow() {
      this.checkedRows = []
      this.$refs.main.clearCheckboxRows()
    },
    async batchSubmit() {
      console.log('批量提报', this.checkedRows)
      const confirm = await this.$confirm(
        this.$l('message_batch_submit_record') || '确认要批量提报吗？',
        this.$l('INDEX.tips_title_confirm') || '确认信息',
        {
          type: 'warning',
          draggable: true,
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确认',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .pendingGoodsWorkLogBatchSubmitApi({ codes: this.checkedCodes })
        .catch(() => null)
      this.loadingClose()

      if (!res) return
      const { status, msg } = res
      const isWarning = status !== 200
      this.$message({
        showClose: true,
        message: msg,
        type: isWarning ? 'warning' : 'success',
      })
      if (isWarning) return
      this.clearCheckboxRow()
      this.reload()
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .dropdown-menu {
  font-size: 14px;
  padding: 4px 0;
}
.submit-button {
  .el-icon-circle-close {
    display: none;
  }
}
.submit-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
